
import React from 'react';
import { Link } from 'react-router-dom';

interface LogoProps {
  scrolled: boolean;
}

const Logo: React.FC<LogoProps> = ({ scrolled }) => {
  return (
    <Link to="/" className={`mr-6 transition-all duration-300 ${scrolled ? 'scale-75' : ''}`}>
      <img 
        src="/logo-2026.png" 
        alt="Afsprakenmaker" 
        width={67}
        height={40}
        className="h-10 w-auto" 
      />
    </Link>
  );
};

export default Logo;
